import { IModel, IViolation, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureStorageLinkedService } from '../linkedservice/azure-storage.linkedservice';
import { HDInsightLinkedService } from '../linkedservice/hdinsight.linkedservice';
import { Activity } from './activity';
import { FilePath } from 'app/model/dataset/file-path';

import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';
import { ParameterConfig } from 'app/model/pipeline/parameter-config';
import { HDInsightOnDemandLinkedService } from 'app/model/linkedservice/hdinsightondemand.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { validateFilePath } from 'app/shared/utils/activity-validation.util';

@Metamodel.model({
    name: 'HDInsightHive',
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.Hive_DisplayText),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.Hive_DisplayText)
    ]
})
export class HiveActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly SCRIPT_PATH: IAttribute;
    public static readonly ARGUMENTS: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_ScriptPath,
        constraint: {
            validator: HiveActivity.validateScriptPath,
            required: true
        },
        association: 'SCRIPT_PATH',
        templatable: true,
        accepts: ['String']
    })
    public scriptPath = new FilePath();
    @Metamodel.attribute({
        display: stringResources.ModelName_Arguments,
        association: 'ARGUMENTS',
        templatable: true,
        accepts: ['Array']
    })
    public hiveActivityArguments?: ParameterConfig[]; // Property name is "arguments" in JSON, needs to workaround with tslint for banned term.
    public getDebugInfo?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Defines,
        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public defines?: ParameterConfig[];

    @Metamodel.attribute({
        display: stringResources.VariablesLabel,
        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public variables?: ParameterConfig[];

    public queryTimeout?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_ScriptLinkedservice,
        constraint: {
            required: true
        },
        reference: true,
        type: AzureStorageLinkedService.MODEL
    })
    public scriptLinkedService?: AzureStorageLinkedService; // Azure Storage linked service which contains the script.

    @Metamodel.attribute({
        display: format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Hdi_DisplayName),
        constraint: {
            required: true
        },
        reference: true,
        type: HDInsightLinkedService.MODEL
    })
    public linkedService?: HDInsightLinkedService | HDInsightOnDemandLinkedService;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ExecutionActivity';
    }

    private static validateScriptPath(_activity?: HiveActivity, arg?: FilePath | undefined): IViolation[] | undefined {
        return validateFilePath(_activity, arg, HiveActivity.SCRIPT_PATH);
    }
}
